<template>
  <div class="main container">
    <loader :isLoading="requestInProgress"/>

    <ProfileNotVerified v-if="!userDetails.is_account_verified && !isShowProfileForm"
        :accountName="accountName"
        :showProfileForm="showProfileForm"
        :userDetails="userDetails"/>

    <div v-else>
      <h4>{{ accountName }}</h4>
      <div class="line"></div>

      <div class="row">
        <div class="col-4">
          <img :src="profilePicture" width="150px" height="150px">
          <br/>
          <button class="btn btn-selfie" v-if="!isTakeSelfie" @click="takeSelfie">
            Take a Selfie
          </button>
          <p>Please submit a solo picture with a clear view of your face</p>
        </div>

        <ProfileForm class="col-8"
          :form="form"
          :genderCategories="genderCategories"
          :validateForm="validateForm"/>
      </div>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/common/Loader'

import ProfileForm from './ProfileForm'
import ProfileNotVerified from './ProfileNotVerified'

import { SELFIE } from '@/api/constants/ImageAssets'
import { APIService } from '@/api/APIService'
import { GENDER_CATEGORIES } from '@/api/constants/Profile'

const api = new APIService()

const assetImage = SELFIE

export default {
  components: {
    Loader,
    ProfileForm,
    ProfileNotVerified
  },
  data() {
    return {
      accountName: '',
      errorMessage: '',
      form: {
        first_name: '',
        last_name: '',
        mobile_number: ''
      },
      // TODO: combine profileDetails to userDetails API response
      profilePicture: '',
      profileDetails: {},
      genderCategories: GENDER_CATEGORIES,
      requestInProgress: false,
      isShowProfileForm: false,
      video: {},
      canvas: {},
      isTakeSelfie: false,
      isStreaming: false,
      stream: {}
    }
  },
  props: {
    userId: String,
    userDetails: Object
  },
  mounted() {
    this.parseUserDetails()
  },
  destroyed() {
    this.stopStreaming()
  },
  watch: {
    userDetails(newVal, oldVal) {
      this.userDetails = newVal
      this.parseUserDetails()
    }
  },
  methods: {
    showProfileForm() {
      this.isShowProfileForm = true
    },
		toTitleCase(str) {
			return str.replace(/(^|\s)\S/g, function(t) { return t.toUpperCase() })
		},
    parseUserDetails() {
      this.form = this.userDetails.profile_details
      this.accountName = this.toTitleCase(
        this.userDetails.profile_details.first_name + ' ' +
        this.userDetails.profile_details.last_name
      )
      this.isShowProfileForm = this.userDetails.is_account_verified
      this.profilePicture = this.userDetails.profile_details.profile_picture
      if(this.profilePicture === 'none') {
        this.profilePicture = assetImage
      }
      // this.firstName = this.toTitleCase(this.userDetails.other_details.first_name)
      // this.lastName = this.toTitleCase(this.userDetails.other_details.last_name)
    },
    getUserProfileDetails() {
      var self = this
      self.requestInProgress = true
      api.getProfileDetails(this.userId).then(data => {
        self.requestInProgress = false
        self.form.profile_details = {...data.profile_details}
        self.profileDetails = {...data.profile_details}
      }).catch(err => {
        self.requestInProgress = false
        self.errorMessage = err
      })
    },
    validateForm() {
      // console.log('profile validate form: ', this.form)
    },
    stopStreaming() {
      if(this.isStreaming) {
        this.stream.getTracks().forEach(track => track.stop())
        this.isStreaming = false
      }
    },
    takeSelfie() {
      this.isTakeSelfie = true
      this.isStreaming = true
      let constraints = { video: true }
      navigator.mediaDevices.getUserMedia(constraints)
        .then(this.handleSuccess)
        .catch(this.handleError);
    },
    handleSuccess(stream) {
      this.video = this.$refs.video
      this.stream = stream
      window.stream = stream
      this.video.srcObject = stream
    },
    handleError(error) {
      this.error = error
    },
    hasGetUserMedia() {
      return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)
    },
    capture() {
      this.canvas = this.$refs.canvas
      // default video width = 640; height = 480
      // var rx = (this.video.videoWidth / 200);
      // var ry = (this.video.videoHeight / 300);
      const canvasCtx = this.canvas.getContext('2d')
      canvasCtx.drawImage(this.video, 0, 0, 400, 400)

      let base64URL = this.canvas.toDataURL('image/png')
      this.imageData = base64URL
      this.isTakeSelfie = false
    },
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/containers/individual_profile/IndividualProfile.vue